/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import type { LogoProps } from '@atlaskit/logo/types';
import Tile from '@atlaskit/tile/tile';

// Import LogoProps from @atlaskit/logo to ensure compatibility

/**
 * __CustomLinkIcon__
 *
 * A custom component to represent the icon for Custom Link using @atlaskit/tile.
 * This replaces the deprecated component from @atlaskit/temp-nav-app-icons/custom-link.
 */
export function CustomLinkIcon({ size = 'medium', label = '', testId }: LogoProps): JSX.Element {
	return (
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		<Tile label={label} size={size} isInset={false} backgroundColor="white" testId={testId}>
			<svg height="100%" viewBox="0 0 24 24">
				<rect
					//eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
					fill="#dddee1"
					x="0"
					y="0"
					width="24"
					height="24"
				/>
				<path
					fill="#101214"
					fillRule="evenodd"
					d="M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75"
					clipRule="evenodd"
				/>
			</svg>
		</Tile>
	);
}
